import React from "react";

import { getGroups, getGroupsKey } from "modules/groups/api/getGroups";

import { useReactQuery } from "components/RemoteData";
import { ChakraText } from "components/ChakraText";
import { ErrorBoundary } from "components/ErrorBoundary/ErrorBoundary";

interface IProps {
  groupId: string;
  friendlyUrl: string;
}

const GroupBreadcrumbThrowable = ({ groupId, friendlyUrl }: IProps) => {
  const { data: groupList } = useReactQuery(getGroupsKey(), () =>
    getGroups(friendlyUrl)
  );

  const selectedGroup = groupList?.find(
    (group) => groupId === group.id.toString()
  );

  if (!selectedGroup) {
    return <></>;
  }

  return <ChakraText>{selectedGroup.name}</ChakraText>;
};

const GroupBreadcrumb = ({ ...props }: IProps) => {
  return (
    <ErrorBoundary fallback={() => <></>}>
      <GroupBreadcrumbThrowable {...props} />
    </ErrorBoundary>
  );
};

export { GroupBreadcrumb };
